
<nav class="navbar pressganeyHeader">
  <div class="logoSec">
     <span class="navbar-brand"><img class="img-fluid" src="assets/images/logo.svg" alt="logo"></span>
     <p class="logo-title">NDNQI</p>
  </div>

  @if (isUserLoggedIn && enableSingleSignOn && isFederationLoaded) {
    <ng-container>
      <app-user-registration class="user-registration-popup" [isUserLoggedIn]="isUserLoggedIn" [isFederationLoaded]="isFederationLoaded" [userEmail]="userEmail"></app-user-registration>
    </ng-container>
  }
</nav>


<!-- Caughron - 7-27-2019 - added notice bar component -->
<app-shared-pg-notice
  (logoutClicked)="onLogoutClicked()"
  [menuLoading]="menuLoading"
  [hideLogout]="hideLogout">
</app-shared-pg-notice>
